import React from 'react';

export const Skeleton = () => <>Loading Skeleton</>;
